import React from 'react';
import cx from 'classnames';

import Image from 'next/image';

import Typography from '../shared/Typography';

import { DATA } from './constants';

type PersonBottomProps = {
  urlImage: string;
  title: string;
  description: string;
  className?: string;
};

const PersonBottom: React.FC<PersonBottomProps> = ({
  title,
  description,
  urlImage,
  className
}) => {
  return (
    <div
      className={cx('w-64 flex flex-col items-center text-center', className)}
    >
      <Image
        className="rounded-full mb-3"
        src={urlImage}
        width={180}
        height={180}
      />
      <Typography className="font-semibold mb-1" type="b1">
        {title}
      </Typography>
      <Typography type="b1">{description}</Typography>
    </div>
  );
};

export type BehindTheMagicProps = {
  className?: string;
};

const BehindTheMagic: React.FC<BehindTheMagicProps> = ({ className }) => {
  return (
    <div className={cx('py-20 flex flex-col', className)}>
      <Typography
        className="text-center max-w-xs mx-auto mb-10 lg:max-w-none lg:mb-16"
        style={{
          fontFamily: 'Libre Baskerville',
          fontWeight: 700,
          fontSize: 32
        }}
      >
        Meet The Keepsake Tales Team
      </Typography>
      <div className="relative w-full">
        <div className="lg:px-40 py-10 items-center mx-auto">
          <div className="flex flex-col flex-wrap items-center gap-10 lg:flex-row lg:justify-between">
            {DATA.map((item, idx) => (
              <PersonBottom
                key={`person-bottom-${idx}-${item.title}`}
                {...item}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BehindTheMagic;
